import { Insta } from "../../src/components/insta/InstaClass";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import UI from "../../src/shell/UI";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { customer } from "../characters/Customer";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { jenny } from "../characters/Jenny";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { alexImages, alexOtherPics, alexProfilesPic } from "../helpers/alexInstaImages";
import { doDoorRing, doSmsSound, doTransition, doWaitImageByTime, isAnnGF } from "../helpers/helpers";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { extras, images, uiImages } from "./images";
import { V6AnnArrived } from "./V6_AnnArrived";
import { V6AnnBeforeAudition_Question } from "./V6_AnnAuditions";
import { V6AnnLibrary } from "./V6_AnnLibrary";
import { V6ChrisMerry } from "./V6_ChrisMerry";
import { V6EmilyCoffeeStart } from "./V6_EmilyCoffee";
import { V6EmilysRoom } from "./V6_EmilyRoom";
import { V6EmilyShopping } from "./V6_EmilyShopping";
import { V6Underpass_Car } from "./V6_Underpass";
import { V6VanessaAtHome } from "./V6_VanessaArrived";
import { V6VanessaCustomerMeeting } from "./V6_VanessaCustomerMeeting";
import { V6VanessaHome } from "./V6_VanessaHomeEvening";
import { V6VanessaShoppingEmilysCar } from "./V6_VanessaShopping";
import { V7Start } from "./V7";
import { annProfilesPic } from "../helpers/annInstaImages";
import { V6EmilyJoeOutside } from "./V6_EmilyJoeOutside";


export const V6Start = async (): Promise<any> => {

    return jump(V6WakingUp, "V6WakingUp");
};

export const V6WakingUp = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room2);
    mc.think(`A new day...`);
    mc.think(`I wonder if I'm gonna have a chill day today or some crazy shit might happen...`);


    if (isAnnGF() && !ann.properties.isCorrupted) {

        return jump(V6AnnArrivedBefore, "V6AnnArrivedBefore");
    }


    return jump(V6VanessaArrivesBefore, "V6VanessaArrivesBefore");

};

export const V6AnnArrivedBefore = async (): Promise<any> => {

    return jump(V6AnnArrived, "V6AnnArrived");
};

export const V6AnnArrivedAfter = async (): Promise<any> => {

    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15_2, { duration: 0.6 });
    mc.think(`Ann left, I can tell Emily she can get ready now.`);

    return jump(V6EmilyRoomBefore, "V6EmilyRoomBefore");
};

export const V6VanessaArrivesBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room2);
    doDoorRing();
    mc.think(`I spoke too soon...`);
    return jump(V6VanessaAtHome, "V6VanessaAtHome");
};

export const V6VanessaArrivesAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_16, { duration: 1 });
    mc.think(`I can tell Emily she can get ready now.`);
    return jump(V6EmilyRoomBefore, "V6EmilyRoomBefore");
};

export const V6EmilyRoomBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_3, { transition: true, duration: 0.6 });
    mc.talk(`I can't hear her, but she must be inside.`);
    ImageClass.setImage(images.v6.EmilyRoom_0);
    mc.think(`She didn't notice me stepping inside...`);
    mc.think(`What is she doing on her laptop?`);
    ImageClass.setAnimation(images.v6.Anim_EmilyRoom);
    mc.think(`She is browsing for some sexy lingeries...`);
    mc.think(`She said she broke up with her boyfriend... So why would she want to buy those now?`);
    mc.talk(`Emily, I'm ready to go.`);
    ImageClass.setImage(images.v6.EmilyRoom_2);
    emily.talk(`${mc.name}! You scared me! I didn't hear you!`);
    mc.think(`She quickly minimized that tab... I guess she doesn't want me to know about that.`);
    mc.talk(`Sorry, didn't mean to scare you.`);
    ImageClass.setImage(images.v6.EmilyRoom_2_2);
    emily.talk(`It's ok.`);
    emily.talk(`Give me a second to have a quick shower. I'll tell you when I'm ready to go.`);
    mc.talk(`Ok, I'll be in my room.`);
    return jump(V6EmilysRoomQuestion, "V6EmilysRoomQuestion");
};

export const V6EmilysRoomQuestion = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6EmilysRoomQuestion`)) {

        ImageClass.setImage(images.v6.MCRoom_0);
    } else {
        // TODO: move this to the insta helper
        await alex.set((properties) => {
            properties.instaFollowing = 112;
            properties.instaFollowers = 256888;
        });
        ImageClass.setImage(images.v6.MCRoom_0, { transition: true, duration: 1 });
    }

    if (!Game.seenScenarios.includes(`V6EmilysRoomQuestion`)) {
        mc.think(`After browsing the web for a few minutes I could hear the shower's water running.`);
        mc.think(`All I am thinking about is why would Emily be browsing that site.`);

    }

    await UI.add({
        key: "v6FirstButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.peekBtn, tooltip: "Look around her room", key: "emilyRoom" },
                { image: uiImages.continue, tooltip: "Wait for Emily", key: "continue" },
            ]
    });
    if (UI._globalUI.v6FirstButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v6FirstButtons === "emilyRoom") {
        return jump(V6EmilysRoom, "V6EmilysRoom");

    }
    if (UI._globalUI.v6FirstButtons === "continue") {
        return jump(V6EmilyRoomAfter, "V6EmilyRoomAfter");

    }
    return jump(V6EmilysRoomQuestion, "V6EmilysRoomQuestion");


};

export const V6VanessaMCCustomerSMSConv = async (): Promise<any> => {
    ImageClass.setImage(images.v6.MCRoom_0);
    
    doSmsSound();
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `Guess where I'm not.`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `How should I know?` });
        Phone.setMessage({ character: vanessa.character, text: `I'm not at work.` });
        Phone.setMessage({ character: vanessa.character, text: `Do you know why?` });
        Phone.setMessage({ character: mc.character, text: `Why?` });
        Phone.setMessage({ character: vanessa.character, text: `Because I lost my job!!!` });
        Phone.setMessage({ character: mc.character, text: `what's that got to do with me?` });
        Phone.setMessage({ character: vanessa.character, text: `The old dude that came to the coffee shop (and I won't say more over texts).` });
        Phone.setMessage({ character: vanessa.character, text: `Apparently he knows some people and he pulled some strings and got me fired!` });
        Phone.setMessage({ character: mc.character, text: `That sucks...` });
        Phone.setMessage({ character: vanessa.character, text: `I need you to help me get it back!` });
        Phone.setMessage({ character: mc.character, text: `How am I going to do that?` });
        Phone.setMessage({ character: vanessa.character, text: `Come by my house, and let's go look for him!` });
        Phone.setMessage({ character: mc.character, text: `What? He could be anywhere!` });
        Phone.setMessage({ character: vanessa.character, text: `Well, since he knows people at the coffee shop we'll start there.` });
        Phone.setMessage({ character: mc.character, text: `Sounds like a goose chase...` });
        Phone.setMessage({ character: vanessa.character, text: `I hope you are a fast runner, because we're gonna go there right now!` });
        Phone.setMessage({ character: mc.character, text: `I can't, I have plans.` });
        Phone.setMessage({ character: vanessa.character, text: `I didn't know you leave the house by yourself.` });
        Phone.setMessage({ character: mc.character, text: `I have plans with my ${emily.properties.relation}, Emily.` });
        Phone.setMessage({ character: vanessa.character, text: `You have a ${emily.properties.relation}??` });
        Phone.setMessage({ character: mc.character, text: `Yup.` });
        Phone.setMessage({ character: vanessa.character, text: `Send nudes` });
        Phone.setMessage({ character: mc.character, text: `...` });
        Phone.setMessage({ character: vanessa.character, text: `Anyway, when are you done with her?` });
        Phone.setMessage({ character: mc.character, text: `I don't know...` });
        Phone.setMessage({ character: vanessa.character, text: `Just do it quick, and text me when you are done.` });
        Phone.setMessage({ character: mc.character, text: `Alright.` });
        Phone.setMessage({ character: vanessa.character, text: `Great! BYE!` });
        Phone.closeMessagesUI();
    });

    mc.think(`Vanessa and her nonsense...`);
    mc.think(`I have no idea how she expects me to get her her job back...`);
    return jump(V6EmilyRoomAfter, "V6EmilyRoomAfter");
};


export const V6EmilyRoomAfter = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`VanessaCoffee1`) && !Game.seenScenarios.includes(`V6VanessaMCCustomerSMSConv`) && !Game.seenScenarios.includes(`V6VanessaArrivesBefore`)) {


        return jump(V6VanessaMCCustomerSMSConv, "V6VanessaMCCustomerSMSConv");
    }

    doWaitImageByTime(images.v6.MCRoom_1, null, 0.6);
    emily.talk(`I'm ready!`);

    if (Game.seenScenarios.includes(`V6EmilysRoomEnter`)) {

        mc.think(`She just finished, I'm glad I didn't get caught.`);
    }
    mc.talk(`Really? That fast? I remember it used to take you ages to get ready.`);
    emily.talk(`I was eager to go so I made it quick!`);
    emily.talk(`I hope you didn't get bored!`);
    if (Game.seenScenarios.includes(`V6EmilysRoomEnter`)) {

        mc.think(`Your phone kept me busy...`);
    }
    mc.talk(`Oh, no, not at all.`);
    emily.talk(`Great! Let's go.`);

    return jump(V6EmilyShoppingBefore, "V6EmilyShoppingBefore");
};

export const V6EmilyShoppingBefore = async (): Promise<any> => {

    return jump(V6EmilyShopping, "V6EmilyShopping");
};

export const V6EmilyShoppingAfter = async (): Promise<any> => {

    return jump(V6EmilyCoffeeBefore, "V6EmilyCoffeeBefore");
};



export const V6EmilyCoffeeBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_36, { transition: true });
    emily.talk(`That was kinda quick, right?`);
    mc.talk(`To be honest, it was.`);
    mc.talk(`Now what?`);
    emily.talk(`I wouldn't mind a cup of coffee.`);
    emily.talk(`I know a place near by if you are up to it.`);
    mc.talk(`Sure, why not.`);
    emily.talk(`Great! I really like the new you!`);
    mc.talk(`Do you want me to help you with the bag?`);
    emily.talk(`I got it, thanks!`);
    mc.talk(`Alright, let's go.`);

    return jump(V6EmilyCoffeeStart, "V6EmilyCoffeeStart");
};

export const V6EmilyCoffeeAfter = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6AnnArrived`)) {

        return jump(V6AnnLibraryBefore, "V6AnnLibraryBefore");
    }

    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true, duration: 1 });
    mc.think(`It was nice spending some time with Emily...`);

    return jump(V6HomeRecap, "V6HomeRecap");
};


export const V6AnnLibraryBefore = async (): Promise<any> => {
    return jump(V6AnnLibrary, "V6AnnLibrary");
};


export const V6AnnLibraryAfter = async (): Promise<any> => {

    return jump(V6HomeRecap, "V6HomeRecap");
};

export const V6VanessaShoppingBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `You have the nerve to make me wait! No guy has ever done that before!`, options: { wait: false } });
        if (Game.seenScenarios.includes(`V6VanessaMCCustomerSMSConv`)) {
            Phone.setMessage({ character: mc.character, text: `What the fuck are you talking about?` });
            Phone.setMessage({ character: vanessa.character, text: `Where are you?` });
            Phone.setMessage({ character: mc.character, text: `At my home.` });
            Phone.setMessage({ character: vanessa.character, text: `I told you to text me when you get home so we'll go look for that pervert grandpa!!! Have you forgot?` });
            Phone.setMessage({ character: mc.character, text: `I just got home, like a few minutes ago.` });
            Phone.setMessage({ character: mc.character, text: `And about that dude, funny story, but I met him.` });
            Phone.setMessage({ character: vanessa.character, text: `What? Where? When?` });
            Phone.setMessage({ character: mc.character, text: `I went with Emily to the coffee shop to have a drink and saw him there.` });
            Phone.setMessage({ character: mc.character, text: `He said that he is willing to meet you in order to get things straight.` });
            if (mc.properties.v3RudeToTheCustomer) {
                Phone.setMessage({ character: vanessa.character, text: `Is he being serious? It's not even my fault!` });
            } else {
                Phone.setMessage({ character: vanessa.character, text: `Is he being serious? It's not like I robbed a bank. I just told him to fuck off. Like what the fuck.` });
            }
            Phone.setMessage({ character: mc.character, text: `He said that you can agree to it or find another job.` });
            Phone.setMessage({ character: vanessa.character, text: `Are you gonna let me deal with it by myself now?` });
            Phone.setMessage({ character: mc.character, text: `No.\nHe said that I can be there with you.` });
            Phone.setMessage({ character: vanessa.character, text: `Oh! That's great!` });
            Phone.setMessage({ character: mc.character, text: `I guess...` });
            Phone.setMessage({ character: vanessa.character, text: `By the way, how did he act?\nDid he seem pissed or anything?` });
            Phone.setMessage({ character: mc.character, text: `Not really. He had this smirk on his face like he knew I would come to talk to him.` });
            Phone.setMessage({ character: vanessa.character, text: `Bastard.` });
            Phone.setMessage({ character: vanessa.character, text: `Anyway, how are you gonna contact him to tell him I'm willing to meet with him?` });
            Phone.setMessage({ character: mc.character, text: `He gave me his number.` });
            Phone.setMessage({ character: vanessa.character, text: `And where does he want to meet?` });
            Phone.setMessage({ character: vanessa.character, text: `Let me guess! A dark creepy alley.` });
            Phone.setMessage({ character: mc.character, text: `He said we can choose the location.` });
            Phone.setMessage({ character: vanessa.character, text: `Oh.\nWell, that's not so bad.` });
            Phone.setMessage({ character: vanessa.character, text: `I'll think of a place to meet and then we'll contact him. Agreed?` });
            Phone.setMessage({ character: mc.character, text: `Sure.` });
            Phone.setMessage({ character: vanessa.character, text: `Since we got that settled. That brings me to my next subject.` });
            Phone.setMessage({ character: vanessa.character, text: `How was the shopping?` });
        } else {
            if (Game.seenScenarios.includes(`V6AnnArrived`)) {
                Phone.setMessage({ character: vanessa.character, text: `How was the shopping?` });
                Phone.setMessage({ character: mc.character, text: `WTF? How do you know about that?` });
                Phone.setMessage({ character: vanessa.character, text: `How do you think? I just got off the phone with Ann.` });
            } else {
                Phone.setMessage({ character: vanessa.character, text: `Are you home yet?` });
                Phone.setMessage({ character: mc.character, text: `Are you stalking me?` });
                Phone.setMessage({ character: vanessa.character, text: `If I did, I wouldn't have asked this question...` });
            }
            Phone.setMessage({ character: vanessa.character, text: `Like DUH!` });
            Phone.setMessage({ character: vanessa.character, text: `Anyway!` });
            Phone.setMessage({ character: vanessa.character, text: `How was it? Did you have fun?` });
        }
        Phone.setMessage({ character: mc.character, text: `It was ok... I guess... Why the sudden interest?` });
        if (mc.properties.annStatus === "hate") {
            Phone.setMessage({ character: vanessa.character, text: `I'm bored.` });
            Phone.setMessage({ character: mc.character, text: `Why didn't you text Joe?` });
            if (mc.properties.joeStatus === "enemy") {
                Phone.setMessage({ character: vanessa.character, text: `He needs some time away from me after all that has happened.` });
            } else {
                Phone.setMessage({ character: vanessa.character, text: `He is at the gym with his stupid friends.` });
            }
            Phone.setMessage({ character: vanessa.character, text: `And stop acting like you are hard to get! I know you don't have any plans.` });
            Phone.setMessage({ character: mc.character, text: `Maybe I do.` });
            Phone.setMessage({ character: vanessa.character, text: `Sure!` });
            Phone.setMessage({ character: vanessa.character, text: `Anyway. You didn't answer my question.` });
            Phone.setMessage({ character: mc.character, text: `About what? How was it to go shopping with Emily?` });
            if (Game.seenScenarios.includes(`V6AnnArrived`)) {
                Phone.setMessage({ character: vanessa.character, text: `Yeah, and that reminded me!\nWhy didn't you tell me you have a {emily.relation} named Emily.` });
                Phone.setMessage({ character: mc.character, text: `We didn't have a chance to talk about those kind of things.` });
                Phone.setMessage({ character: vanessa.character, text: `Whatever!` });
                Phone.setMessage({ character: vanessa.character, text: `Anyway, how was it?` });
            } else {
                Phone.setMessage({ character: vanessa.character, text: `Yeah.` });
            }
            Phone.setMessage({ character: mc.character, text: `It was ok, nothing special. Why?` });
            Phone.setMessage({ character: vanessa.character, text: `I need to buy some clothes for a friend and I was wondering if that store is worth something.` });
            Phone.setMessage({ character: mc.character, text: `I guess you can find some things in there.` });
            Phone.setMessage({ character: vanessa.character, text: `Great! So come pick me up and we'll go together.` });
            Phone.setMessage({ character: mc.character, text: `Haha, nice joke.` });
        } else {
            Phone.setMessage({ character: vanessa.character, text: `I was just curious what you bought for Ann.` });
            Phone.setMessage({ character: mc.character, text: `Huh? Nothing, I just joined Emily... She was the only one shopping.` });
            Phone.setMessage({ character: vanessa.character, text: `WTF! Are you serious?` });
            Phone.setMessage({ character: mc.character, text: `I am.` });
            if (Game.seenScenarios.includes(`V5AnnMovie`)) {
                Phone.setMessage({ character: vanessa.character, text: `I was hoping you'd buy something for her, because she may have changed her clothing a bit but her lingerie still sucks.` });

            } else {
                Phone.setMessage({ character: vanessa.character, text: `I was hoping you'd buy something for her.` });
                Phone.setMessage({ character: vanessa.character, text: `You know... So she could wear something nice underneath her shitty clothes.` });
            }
            Phone.setMessage({ character: mc.character, text: `I didn't think about that...` });
            Phone.setMessage({ character: vanessa.character, text: `There is only one way to fix that.` });
            Phone.setMessage({ character: mc.character, text: `How?` });
            Phone.setMessage({ character: vanessa.character, text: `We are going over there right now!` });
            Phone.setMessage({ character: mc.character, text: `Are you serious? I just got home. I was planning to relax for a bit.` });
        }
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}.` });
        Phone.setMessage({ character: mc.character, text: `?` });
        Phone.setMessage({ character: vanessa.character, text: `The more you keep arguing the more it will be difficult for you to say yes at the end.` });
        Phone.setMessage({ character: vanessa.character, text: `So let's stop wasting time.` });
        Phone.setMessage({ character: mc.character, text: `Fine.` });
        Phone.setMessage({ character: mc.character, text: `Are you coming over? It's closer to my home.` });
        if (Game.seenScenarios.includes(`V6AnnArrived`)) {
            Phone.setMessage({ character: vanessa.character, text: `Is that a way to treat a lady? You should come and pick me up!` });
            Phone.setMessage({ character: mc.character, text: `Well... Emily said I can take her car...` });
            Phone.setMessage({ character: vanessa.character, text: `Great!!!` });
        } else {
            Phone.setMessage({ character: vanessa.character, text: `No way! Take Emily's car and come pick me up! That's why you agreed to go with her in the first place.` });
            Phone.setMessage({ character: mc.character, text: `True...` });
            Phone.setMessage({ character: vanessa.character, text: `Great!!!` });
        }
        Phone.setMessage({ character: vanessa.character, text: `I'll be waiting outside... Gimme 5 minutes.` });
        Phone.setMessage({ character: mc.character, text: `Cya soon.` });
        Phone.closeMessagesUI();
    });


    mc.think(`I guess I'm going back to the clothing store...`);
    return jump(V6VanessaShoppingEmilysCar, "V6VanessaShoppingEmilysCar");
};


export const V6VanessaShoppingAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaPickup_2, { transition: true, duration: 0.6 });
    vanessa.talk(`Thanks!`);
    vanessa.talk(`Don't forget! Meet me here in a couple of hours.\nI just need my parents to leave the house.`);
    mc.talk(`Sure, I'll be here.`);
    vanessa.talk(`Bye.`);

    return jump(V6HomeRecap, "V6HomeRecap");
};

export const V6AnnPhoneCall = async (): Promise<any> => {

    return jump(V6AnnAuditionBefore, "V6AnnAuditionBefore");
};

export const V6AnnAuditionBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    doDoorRing();
    mc.think(`Now what?`);
    ImageClass.setImage(images.v6.AnnArrivedNew_0, { transition: true, duration: 1 });
    mc.think(`Is that... Ann?`);
    ImageClass.setImage(images.v6.AnnArrivedNew_1);
    mc.think(`Woah... Ann? What happened to her clothes?`);
    if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined4`)) {
        mc.think(`I haven't had the chance to talk to her since yesterday...`);
        mc.think(`Vanessa just joined us in the middle of sex. And when I tried to talk to Ann after, she just sat there and didn't answer me, so I left.`);

    }
    ann.talk(`Hey ${mc.name}!`);
    ann.talk(`You look shocked, hehe.`);
    mc.talk(`Yeah, I didn't expect that outfit.`);
    // ann.talk(`I figured I'll try something different.`);
    ann.talk(`I got so many good comments on my previous one that I decided to go for something more extreme! Hehe.`);

    return jump(V6AnnBeforeAudition_Question, "V6AnnBeforeAudition_Question");
};

export const V6AnnAuditionNo1After = async (): Promise<any> => {

    return jump(V6HomeRecap, "V6HomeRecap");
};

// export const SUB_AlexPostsTo30 = async (): Promise<any> => {
// 	<action type="vmod" name="insta.postsNum" do="set" value="30"/>

// 	<action type="vmod" name="temp.tn1" do="set" value="1"/>
// 	<action type="vmod" name="temp.tn2" do="set" value="500"/>
// 	<action type="sub" scenario="SUB_InstaRandomLikesAlex"/>


// 	<action type="vmod" name="temp.tn1" do="set" value="1"/>
// 	<action type="vmod" name="temp.tn2" do="set" value="50"/>
// 	<action type="sub" scenario="SUB_InstaRandomLikesAnn"/>
// }

export const V6HomeRecap = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);

    if (!Game.seenScenarios.includes(`V6HomeRecap`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 112;
            properties.instaFollowers = 316888;
        });
    }

    await UI.add({
        key: "v6RecapButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Pass time", key: "continue" }
            ]
    });
    if (UI._globalUI.v6RecapButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v6RecapButtons === "continue") {
        if (!Game.seenScenarios.includes(`V6VanessaShoppingBefore`)) {

            return jump(V6VanessaShoppingBefore, "V6VanessaShoppingBefore");
        }
        if (!Game.seenScenarios.includes(`V6AnnPhoneCall`)) {
            if (isAnnGF() && ann.properties.isCorrupted) {
                return jump(V6AnnPhoneCall, "V6AnnPhoneCall");

            }

        }

        return jump(V6VanessaHomeBefore, "V6VanessaHomeBefore");

    }
    return jump(V6HomeRecap, "V6HomeRecap");

};
export const V6VanessaHomeBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });
    empty.think(`*Beep beep*`);

    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `HELLLLOOOOOO!!`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `?`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `?`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `?`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `?`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Jeez, relax.` });
        Phone.setMessage({ character: vanessa.character, text: `You are late! Everyone is already here!` });
        Phone.setMessage({ character: mc.character, text: `You told me to come in the evening but you didn't give me an exact time.` });
        Phone.setMessage({ character: vanessa.character, text: `The time is now.` });
        Phone.setMessage({ character: mc.character, text: `Fine, on my way right now.` });
        Phone.setMessage({ character: vanessa.character, text: `FASTER!` });
        Phone.setMessage({ character: vanessa.character, text: `🤡` });
        Phone.setMessage({ character: mc.character, text: `?` });
        Phone.setMessage({ character: vanessa.character, text: `MISCLICK` });
        Phone.setMessage({ character: vanessa.character, text: `😡` });
        Phone.closeMessagesUI();
    });

    mc.think(`She's crazy as always... Anyway, time to go to her place.`);
    return jump(V6VanessaHome, "V6VanessaHome");
};
export const V6VanessaHomeAfter = async (): Promise<any> => {

    if (mc.properties.joeStatus !== "enemy" && ann.properties.isCorrupted && isAnnGF() && !Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt`)) {

        return jump(V6UnderPassBefore, "V6UnderPassBefore");
    }
    if (Game.seenScenarios.includes(`V6EmilyCoffeeCustomer`)) {

        return jump(V6VanessaCustomerMeetingBefore, "V6VanessaCustomerMeetingBefore");
    }

    if (mc.properties.annStatus === "hate" || !ann.properties.isCorrupted) {
        ImageClass.setImage(images.v6.VanessaHouseOutsideDark_0);
        mc.talk(`So, now what?`);
        vanessa.talk(`Well. I won't keep you here. I'm just gonna wait for a bit before going back inside.`);
        vanessa.talk(`I bet it wouldn't take them long to fall asleep. YUK!`);
        mc.talk(`Are you sure?`);
        vanessa.talk(`Yeah.`);
        mc.talk(`Alright. Feel free to call me if you change you mind.`);
        mc.talk(`Cya!`);

    }
    return jump(V6EndDay, "V6EndDay");
};



export const V6VanessaCustomerMeetingBefore = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6Underpass`)) {
        
    doSmsSound();
        await Phone.showMessagesUI({ name: customer.name }, async () => {
            Phone.setMessage({ character: customer.character, text: `Meet me with the girl at the bar near the coffee shop.`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `What? Now?` });
            Phone.setMessage({ character: customer.character, text: `Yes. I'll be waiting. Bye` });

            Phone.closeMessagesUI();
        });
        mc.think(`The things I got involved with...`);
        mc.think(`I should tell Vanessa...`);
        await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
            Phone.setMessage({ character: mc.character, text: `Are you still awake?`, options: { wait: false } });
            Phone.setMessage({ character: vanessa.character, text: `What do you want? Me and Mr. Sweet are having some quality time.` });
            if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {

                Phone.setMessage({ character: mc.character, text: `Isn't that your dildo?` });
                Phone.setMessage({ character: vanessa.character, text: `Like duh!\nSo what do you want? I'm busy here!` });
            } else {

                Phone.setMessage({ character: mc.character, text: `who is that...?` });
                Phone.setMessage({ character: vanessa.character, text: `My dildo! Like duh!\nSo what do you want? I'm busy here!` });
            }
            Phone.setMessage({ character: mc.character, text: `I just got a text from the creepy grandpa... He wants to meet us right now.` });
            Phone.setMessage({ character: vanessa.character, text: `FUCK!!!!!!!` });
            Phone.setMessage({ character: vanessa.character, text: `FINE let's go meet him.` });
            Phone.closeMessagesUI();
        });

        return jump(V6VanessaCustomerMeeting, "V6VanessaCustomerMeeting");

    }
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival`)) {
        doTransition(images.v5.Room2_2);

        if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt`)) {
            mc.think(`What the fuck was that shit?`);
            mc.think(`That was Vanessa's idea to get me and Joey friends again? WTF?`);
            empty.think(`*Buzz Buzz*`);

        } else {
            mc.think(`That was... Unexpected... I hope Ann is ok.`);
            empty.think(`*Buzz Buzz*`);

        }

        await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
            if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt`)) {

                Phone.setMessage({ character: vanessa.character, text: `Why did you leave like that?`, options: { wait: false } });
                Phone.setMessage({ character: mc.character, text: `Are you asking that seriously?` });
                Phone.setMessage({ character: vanessa.character, text: `Of course.` });
                Phone.setMessage({ character: mc.character, text: `Why did you think I would agree to that?` });
                Phone.setMessage({ character: vanessa.character, text: `That's the vibe I got from you.` });
                Phone.setMessage({ character: vanessa.character, text: `Anyway! Chill, nothing happened anyway.` });
                Phone.setMessage({ character: mc.character, text: `Because I stopped it.` });
                Phone.setMessage({ character: vanessa.character, text: `Jeez... Fine, are you gonna continue to preach about that?` });
                Phone.setMessage({ character: mc.character, text: `No, I'm good.` });
                Phone.setMessage({ character: vanessa.character, text: `Good. So to a different subject.` });
                Phone.setMessage({ character: vanessa.character, text: `Since the evening ended faster than I had planned.` });
                Phone.setMessage({ character: vanessa.character, text: `Why don't you send that grandpa a text and tell him I wanna meet with him?` });
                Phone.setMessage({ character: mc.character, text: `Really? After all of that that's what you think about?` });
                Phone.setMessage({ character: vanessa.character, text: `OMG! RELAX! Ann isn't even mad at you, she saw you stopped it.` });
                Phone.setMessage({ character: mc.character, text: `Fine! What do you need me to do?` });
                Phone.setMessage({ character: vanessa.character, text: `Text him, tell him we wanna meet with him right now.` });
                Phone.setMessage({ character: mc.character, text: `We?` });
                Phone.setMessage({ character: vanessa.character, text: `Of course, I'm not gonna meet with him by myself.` });
                Phone.setMessage({ character: mc.character, text: `Fine. But isn't it late?` });
            } else {
                Phone.setMessage({ character: vanessa.character, text: `Helloooooooo`, options: { wait: false } });
                Phone.setMessage({ character: mc.character, text: `You really need to learn how to start texting.` });
                Phone.setMessage({ character: vanessa.character, text: `I just wanted to let you know that both Ann and Joe left my home.` });
                Phone.setMessage({ character: vanessa.character, text: `And no, no fucking was involved.` });

                Phone.setMessage({ character: mc.character, text: `Thanks for letting me know.` });

                Phone.setMessage({ character: vanessa.character, text: `Of course! So what are you doing right now?` });
                Phone.setMessage({ character: mc.character, text: `Nothing really. About to go to sleep, why?` });
                Phone.setMessage({ character: vanessa.character, text: `I planned the evening to be much longer, but my stupid parents ruined my plans. So I'm thinking that now is a good time to contact the grandpa.` });
                Phone.setMessage({ character: mc.character, text: `Really? Now? Isn't it late?` });
            }
            Phone.setMessage({ character: vanessa.character, text: `No way. I bet he's gonna answer in seconds.` });
            Phone.setMessage({ character: mc.character, text: `I can try... But where do you want to meet with him?` });
            Phone.setMessage({ character: vanessa.character, text: `Mmm...` });
            Phone.setMessage({ character: vanessa.character, text: `Oh! I know. Tell him to meet us at the bar.` });
            Phone.setMessage({ character: mc.character, text: `Are you sure about that?` });
            Phone.setMessage({ character: vanessa.character, text: `Positive. Just do it.` });
            Phone.setMessage({ character: mc.character, text: `Alright, gimme a minute.` });
            Phone.closeMessagesUI();
        });




    } else {
        ImageClass.setImage(images.v6.VanessaHouseOutsideDark_0);
        if (Game.seenScenarios.includes(`V6VanessaShoppingLeaving`)) {
            vanessa.talk(`Wait! Didn't you say you have that old dude's number?`);
            mc.talk(`I do.`);
            vanessa.talk(`Text him.`);
        } else {

        }
        if (!Game.seenScenarios.includes(`V6VanessaShoppingLeaving`)) {
            mc.talk(`Oh, I just remembered.`);
            mc.talk(`I've talked to that dude that got you fired.`);
            vanessa.talk(`Why didn't you tell me that sooner?`);
            mc.talk(`I didn't have the time.`);
            mc.talk(`Anyway. He gave me his number and he said he wanna meet with you.`);
            vanessa.talk(`That creepy old bastard.`);
            vanessa.talk(`Where does he want to meet?`);
            mc.talk(`That's up to us.`);
            vanessa.talk(`So what are you waiting for? Text him.`);
        }


        if (!Game.seenScenarios.includes(`V6VanessaCustomerMeetingBefore`)) {
            mc.talk(`Really? Now? Isn't it late?`);
            vanessa.talk(`No way. I bet he's gonna answer in a second.`);
            mc.talk(`I can try... But where do you want to meet with him?`);
            vanessa.talk(`Mmm... Oh, I know. Tell him to meet us at the bar.`);
            mc.talk(`Are you sure about that?`);
            vanessa.talk(`Positive. Just do it.`);
            mc.talk(`Fine.`);

        }


    }
    mc.think(`Fuck I didn't even ask for his name.`);
    await Phone.showMessagesUI({ name: customer.name }, async () => {
        Phone.setMessage({ character: mc.character, text: `Hey, this is ${mc.name}, we've met today at the coffee shop... You told me to contact you when me and my friend are ready to meet.`, options: { wait: false } });
        Phone.setMessage({ character: customer.character, text: `Where?` });
        Phone.setMessage({ character: mc.character, text: `There is a bar not far from the coffee shop, we can be there in ten minutes.` });
        Phone.setMessage({ character: customer.character, text: `I'll be there.` });
        Phone.setMessage({ character: customer.character, text: `Bye.` });
        Phone.closeMessagesUI();
    });



    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival`)) {
        mc.talk(`I'll let Vanessa know.`);
        await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
            Phone.setMessage({ character: mc.character, text: `Ok so I've talked to him. He said he's gonna meet us there.`, options: { wait: false } });
            Phone.setMessage({ character: vanessa.character, text: `Amazing! cya there.` });
            Phone.setMessage({ character: mc.character, text: `Suddenly you don't need me to give you a lift?` });
            Phone.setMessage({ character: vanessa.character, text: `Don't test me.` });
            Phone.setMessage({ character: mc.character, text: `Cya there.` });
            Phone.closeMessagesUI();
        });

        mc.talk(`I guess I ain't going to sleep right now.`);

    } else {
        vanessa.talk(`Well?`);
        mc.talk(`He's gonna meet us there.`);
        vanessa.talk(`Great, let's go.`);
    }

    return jump(V6VanessaCustomerMeeting, "V6VanessaCustomerMeeting");
};

export const V6VanessaCustomerMeetingAfter = async (): Promise<any> => {
    if (mc.properties.agreeToChrisProposal === undefined) {

        return jump(V6ChrisMerryBefore, "V6ChrisMerryBefore");
    }

    return jump(V6EndDay, "V6EndDay");
};

export const V6ChrisMerryBefore = async (): Promise<any> => {


    return jump(V6ChrisMerry, "V6ChrisMerry");
};

export const V6ChrisMerryAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);

    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival`)) {

        mc.think(`I better head home.`);
    } else {

        mc.think(`Vanessa left with Joey already... I better head home.`);
    }
    return jump(V6EndDay, "V6EndDay");
};

export const V6UnderPassBefore = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6VanessaCustomerMeetingAfter`)) {

        return jump(V6EndDay, "V6EndDay");
    }
    return jump(V6Underpass_Car, "V6Underpass_Car");


};
export const V6UnderPassAfter = async (): Promise<any> => {
    return jump(V6EndDay, "V6EndDay");
};


export const V6JennySMSConversation = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Room2_2);
    empty.think(`*Buzz Buzz*`);
    await Phone.showMessagesUI({ name: `Unknown Number` }, async () => {
        Phone.setMessage({ character: jenny.character, text: `Hey! Guess who!`, options: { wait: false } });
        Phone.talk({ character: mc.character, text: `MMM... Only two people know my phone... The girl from the beach, Jenny, and the guy from the clothing store, I think his name was Mario.`, options: { wait: false, think: true } });

        await Phone.setQuestion({
            character: mc.character, question:
                new Question({ text: ``, options: { think: true }, key: `v6JennySMSGuessedJenny` })
                    .option({ title: `Mmm... Jenny?`, key: true })
                    .option({ title: `Mario?`, key: false })
        });
        Phone.talk({ character: mc.character, text: ``, options: { wait: false, think: true } });

        if (Question.globalAnswers.v6JennySMSGuessedJenny) {
            Phone.setMessage({ character: mc.character, text: `Mmm... Jenny?` });
            await mc.set((properties) => {
                properties.jennyRelationship++;
            });
            Phone.setMessage({ character: jenny.character, text: `You remembered my name!` });
            Phone.setMessage({ character: mc.character, text: `Of course, how could I forget?` });
            Phone.setMessage({ character: jenny.character, text: `:))` });

        } else {

            Phone.setMessage({ character: mc.character, text: `I don't know... Mario?` });
            Phone.setMessage({ character: jenny.character, text: `No... Try again` });
            Phone.setMessage({ character: mc.character, text: `The teacher from my 1st grade?` });
            Phone.setMessage({ character: jenny.character, text: `LOL! No! It's Jenny... We've met at the beach.` });
            Phone.setMessage({ character: mc.character, text: `Haha, that was my 3rd guess!` });
            Phone.setMessage({ character: jenny.character, text: `Lol liar!` });
            Phone.setMessage({ character: mc.character, text: `Now you will never find out.` });
            Phone.setMessage({ character: jenny.character, text: `:(` });
        }
        Phone.setMessage({ character: jenny.character, text: `So, how was your day?` });



        Phone.setMessage({ character: mc.character, text: `Long... How was yours?` });
        Phone.setMessage({ character: jenny.character, text: `Holy shit! Today was a nightmare. I woke up early! At like 6am, I got into the shower, and I had no warm water, so I had to get out and wait for the fucking water. So I figured I'll just drink a cup of coffee while waiting for the water to heat up, and then I saw I had no milk... So yeah... I ended up drinking water... And that was just the first hour of my day!` });
        Phone.setMessage({ character: mc.character, text: `Damn... That's unfortunate.` });

        Phone.setMessage({ character: jenny.character, text: `IKR!` });
        Phone.setMessage({
            character: jenny.character, text: `Anyway, after I finally managed to have a shower, I stepped outside my apartment to find out my car broke down and I couldn't get a taxi since it was so early... Like holy shit, how unlucky can I be right? So I decided to take the bus and it was empty, so I said to myself... Well, at least I have some peace and quiet, but suddenly some fat ugly dude stepped into the bus and decided to sit right next to me. I asked him to sit somewhere else, but he was like. "That's my spot..." wtf is wrong with people?`
        });

        Phone.talk({ character: mc.character, text: `Holy shit I don't remember her talking so much.`, options: { think: true } });
        Phone.talk({ character: mc.character, text: '', options: { wait: false, think: true } });

        Phone.setMessage({ character: jenny.character, text: `And don't get me started with what happened after I finally arrived at my office!` });
        Phone.setMessage({ character: jenny.character, text: `Anyway, I'm really bored. What are you doing?` });
        Phone.setMessage({ character: mc.character, text: `Just laying in my bed.` });
        Phone.setMessage({ character: jenny.character, text: `So soon?` });
        Phone.setMessage({ character: mc.character, text: `Yeah... It's been a long day.` });
        Phone.setMessage({ character: jenny.character, text: `Did you think about me??` });
        Phone.setMessage({ character: mc.character, text: `Of course!` });
        Phone.setMessage({ character: jenny.character, text: `lol liar!` });
        Phone.setMessage({ character: jenny.character, text: `Have you been to the beach today?` });
        Phone.setMessage({ character: mc.character, text: `No, today I haven't.` });
        Phone.setMessage({ character: jenny.character, text: `Yeah... Me neither, hoping to go tomorrow.` });
        Phone.setMessage({ character: jenny.character, text: `Maybe I'll see you there! If you will recognize me.` });


        Phone.setImage({ ...images.v6.JennyPhone_0, character: jenny.character });

        Phone.setMessage({ character: jenny.character, text: `Here, so you won't forget what I look like.` });
        Phone.setMessage({ character: jenny.character, text: `(I took it just now btw)` });


        await Phone.setQuestion({
            character: mc.character, question:
                new Question({ text: `She is flirting with me.`, options: { think: false }, key: `v6JennySMSFlirtedBack` })
                    .option({ title: `Flirt back`, key: true })
                    .option({ title: `Don't flirt`, key: false })
        });
        Phone.talk({ character: mc.character, text: '', options: { wait: false, think: true } });
        if (Question.globalAnswers.v6JennySMSFlirtedBack) {
            await mc.set((properties) => {
                properties.jennyRelationship++;
            });
            Phone.setMessage({ character: mc.character, text: `You are so hot.` });
            Phone.setMessage({ character: jenny.character, text: `🥰` });

        } else {
            Phone.setMessage({ character: mc.character, text: `Now I won't forget.` });
            Phone.setMessage({ character: jenny.character, text: `😁` });
        }

        Phone.setMessage({ character: jenny.character, text: `What about you? Am I going to get a pic as well? (Btw I remember how you look like so the face is not needed :P).` });
        await Phone.setQuestion({
            character: mc.character, question:
                new Question({ text: `Should I send her something?`, options: { think: false }, key: `v6JennySMSSentHerPic` })
                    .option({ title: `Send her`, key: true })
                    .option({ title: `Don't send`, key: false })
        });
        if (Question.globalAnswers.v6JennySMSSentHerPic) {

            ImageClass.setImage(images.v6.JennyPhone_5, { duration: 1.5 });
            Phone.setImage({ ...images.v6.JennyPhone_5, character: mc.character });
            Phone.setMessage({ character: jenny.character, text: `I LIKE!` });
            Phone.setMessage({ character: jenny.character, text: `You understand hints 😉` });
            Phone.setMessage({ character: mc.character, text: `Of course` });
            Phone.setMessage({ character: jenny.character, text: `Can I tell you something?` });
            Phone.setMessage({ character: mc.character, text: `Yeah.` });
            Phone.setMessage({ character: jenny.character, text: `I won't lie, a lot of people hit on me and I always just delete their numbers... But I decided to send you a message. I don't know why but I'm glad I did!` });
            Phone.setMessage({ character: mc.character, text: `Me too!` });
            Phone.setMessage({ character: jenny.character, text: `Btw, I forgot to mention that I bought new PJ's! Wanna see?` });
            Phone.setMessage({ character: mc.character, text: `Of course!` });

            Phone.setImage({ ...images.v6.JennyPhone_1, character: jenny.character });

            Phone.setMessage({ character: jenny.character, text: `Do you like?` });

            Phone.setMessage({ character: mc.character, text: `Damn...` });
            Phone.setMessage({ character: jenny.character, text: `You are the first one to see them.` });
            Phone.setMessage({ character: mc.character, text: `And hoping to be the last.` });

            Phone.setMessage({ character: jenny.character, text: `I'm glad you like it, but I'm still gonna switch to my old one before going to sleep... Since it's more comfortable...` });
            Phone.setMessage({ character: mc.character, text: `More comfortable than what you showed me?` });
            Phone.setMessage({ character: jenny.character, text: `Yes...` });
            Phone.setImage({ ...images.v6.JennyPhone_3, character: jenny.character });

            Phone.setMessage({ character: mc.character, text: `Fuck... That definitely looks comfortable...` });
            Phone.setMessage({ character: mc.character, text: `Now I'm interested to see it from the other angle...` });
            Phone.setMessage({ character: jenny.character, text: `Sec` });
            Phone.setImage({ ...images.v6.JennyPhone_2, character: jenny.character });

            Phone.setMessage({ character: mc.character, text: `😍` });

            Phone.setMessage({ character: jenny.character, text: `I gave you something to dream on...` });
            Phone.setMessage({ character: jenny.character, text: `Going to sleep now, it was nice talking to you :)` });
        } else {
            Phone.setMessage({ character: mc.character, text: `Guy's pics are boring` });
            Phone.setMessage({ character: jenny.character, text: `Too bad!` });
            Phone.setMessage({ character: jenny.character, text: `Well. Nice talking to you! Good night.` });
            Phone.setMessage({ character: mc.character, text: `Good night` });
        }


        Phone.closeMessagesUI();
    });

    if (Question.globalAnswers.v6JennySMSSentHerPic) {

        mc.think(`I was wondering when I'll hear from her again...`);
    } else {

        mc.think(`I think I fucked up...`);
    }


    return jump(V6EndDay, "V6EndDay");
};

export const V6AlexEasterEgg2 = async (): Promise<any> => {
    
    doSmsSound();
    mc.think(`I just got a text.`);
    await Phone.showMessagesUI({ name: alex.name }, async () => {
        Phone.setMessage({ character: alex.character, text: `Hey!`, options: { wait: false } });
        Phone.setMessage({ character: alex.character, text: `Thanks for the likes😘` });
        Phone.setMessage({ character: alex.character, text: `I have a picture I took today to show my appreciation to you... Wanna see?` });
        await Phone.setMessage({ character: mc.character, text: `Of course!` });
        Phone.setMessage({ character: alex.character, text: `Imagine yourself as the pillow 😉`, options: { wait: false } });
        Phone.setImage({ ...alexOtherPics.Alex_ee1, character: alex.character, options: { wait: false } });
        await Phone.setQuestion({
            character: mc.character, question:
                new Question({ text: `How should I respond?`, options: { think: false }, key: `V6AlexEasterToldHerSheIsHot` })
                    .option({ title: `You're cute`, key: false })
                    .option({ title: `You're hot`, key: true })
        });

        if (Question.globalAnswers.V6AlexEasterToldHerSheIsHot) {
            Phone.setMessage({ character: mc.character, text: `You're hot!` });
            Phone.setMessage({ character: alex.character, text: `rawr! :D` });
        } else {
            Phone.setMessage({ character: mc.character, text: `You're cute!` });
            Phone.setMessage({ character: alex.character, text: `😘` });
        }
        Phone.setMessage({ character: alex.character, text: `It's your turn now!` });
        Phone.setMessage({ character: mc.character, text: `?` });
        Phone.setMessage({ character: alex.character, text: `send me something` });
        await Phone.setQuestion({
            character: mc.character, question:
                new Question({ text: `What should I send?`, options: { think: false }, key: `V6AlexEasterWhatMCSent` })
                    .option({ title: `Send tease`, key: `tease` })
                    .option({ title: `Send nude`, key: `nude` })
                    .option({ title: `Nothing`, key: `nothing` })
        });

        if (Question.globalAnswers.V6AlexEasterWhatMCSent === "tease") {
            Phone.setMessage({ character: mc.character, text: `Alright! Gimme a second.` });
            ImageClass.setImage(images.v6.JennyPhone_5, { duration: 1.5 });
            Phone.setImage({ ...images.v6.JennyPhone_5, character: mc.character });
            Phone.setMessage({ character: alex.character, text: `Nice pants...` });
            Phone.setMessage({ character: mc.character, text: `I understand` });
            Phone.setMessage({ character: alex.character, text: `😉` });
        } else if (Question.globalAnswers.V6AlexEasterWhatMCSent === "nude") {
            Phone.setMessage({ character: mc.character, text: `Alright! Get ready.` });
            Phone.setMessage({ character: alex.character, text: `🙄` });
            ImageClass.setImage(images.v6.JennyPhone_6, { duration: 1.5 });
            Phone.setImage({ ...images.v6.JennyPhone_6, character: mc.character });
            Phone.setMessage({ character: alex.character, text: `😳` });
            Phone.setMessage({ character: mc.character, text: `Not what you had in mind?` });
            Phone.setMessage({ character: alex.character, text: `Haha... After my pic I figured you'd send something like that... You are a man after all.` });
            Phone.setMessage({ character: mc.character, text: `So I guess I made the right choice?` });
            Phone.setMessage({ character: alex.character, text: `All I can say is this:` });
            Phone.setImage({ ...alexOtherPics.Alex_ee2, character: alex.character });
            Phone.setMessage({ character: mc.character, text: `I'll take that as a yes :)` });
            Phone.setMessage({ character: alex.character, text: `😘` });

        } else {
            Phone.setMessage({ character: mc.character, text: `I dunno if that's a good idea...` });
            Phone.setMessage({ character: alex.character, text: `why?` });
            if (Question.globalAnswers.v5ToldRealInstaUserName) {
                Phone.setMessage({ character: alex.character, text: `oh... is that because of Ann?` });
                if (Question.globalAnswers.v5ToldAlexYouAreAnsBF) {
                    Phone.setMessage({ character: alex.character, text: `I'm just bored and was into some innocent fun. But I get it! you are right.` });

                } else {
                    Phone.setMessage({ character: alex.character, text: `you didn't even introduce yourself as her bf the other day` });
                    Phone.setMessage({ character: mc.character, text: `yeah... but still.` });
                    Phone.setMessage({ character: alex.character, text: `don't worry 😊` });

                }
            } else {
                Phone.talk({ character: mc.character, text: `I don't know if she's knows my connection to Ann... I better play it safe`, options: { think: true } });
                Phone.talk({ character: mc.character, text: ``, options: { think: true, wait: false } });
                Phone.setMessage({ character: mc.character, text: `I just don't have anything to send.` });
                Phone.setMessage({ character: alex.character, text: `you could've taken one right now, but no worries!` });
            }

            Phone.setMessage({ character: alex.character, text: `anyways I'm going to sleep! good night` });

            return Phone.closeMessagesUI();
        }
        Phone.setMessage({ character: alex.character, text: `going to sleep now! Good night 💋` });
        Phone.closeMessagesUI();
    });


    if (Game.currentScene === "V5AlexEasterEgg2") {

    } else {

        return jump(V6EndDay, "V6EndDay");
    }

};
export const V6EmilyJoeOutsideBefore = async (): Promise<any> => {
    return jump(V6EmilyJoeOutside, "V6EmilyJoeOutside");
};
export const V6EmilyJoeOutsideAfter = async (): Promise<any> => {
    return jump(V6EndDay, "V6EndDay");
};
export const V6EndDay = async (): Promise<any> => {
    if (Question.globalAnswers.v1EnableNTR && mc.properties.joeStatus === "enemy" && !Game.seenScenarios.includes(`V6EmilyJoeOutsideBefore`)) {
        doTransition(images.v5.Room2_2);
        return jump(V6EmilyJoeOutsideBefore, "V6EmilyJoeOutsideBefore");
    } else {

        ImageClass.setImage(images.v5.Room2_2);
    }

    if (!Game.seenScenarios.includes(`V6EndDay`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 125;
            properties.instaFollowers = 412322;
        });
        if (Game.seenScenarios.includes(`V6EmilyCoffeeCustomer`) && !Game.seenScenarios.includes("V6VanessaCustomerMeetingBefore")) {

            return jump(V6VanessaCustomerMeetingBefore, "V6VanessaCustomerMeetingBefore");
        }
    }

    if (ann.properties.isCorrupted || Game.seenScenarios.includes(`V5AnnMovie`)) {
        await ann.set((properties) => {
            properties.hasInsta = true;
            properties.instaDescription = `I want to be an actress!`;
        });
    }

    const alexLikes = Insta.instaProfiles?.[alex.name]?.images.reduce((counter, imageCur, index) => (counter + (imageCur.mcLiked ? 1 : 0)), 0);
    if (!Game.seenScenarios.includes(`V6AlexEasterEgg2`) && !Game.seenScenarios.includes(`V5AlexEasterEgg2`)) {
        if (alexLikes >= 25) {
            return jump(V6AlexEasterEgg2, "V6AlexEasterEgg2");
        }

    } else {

    }

    await UI.add({
        key: "v6EndDayButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.sleepBtn, tooltip: "End day", key: "continue" }
            ]
    });
    if (UI._globalUI.v6EndDayButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v6EndDayButtons === "continue") {
        if (!Game.seenScenarios.includes(`V6JennySMSConversation`) && mc.properties.hasJennysNumber) {
            return jump(V6JennySMSConversation, "V6JennySMSConversation");

        }

        return jump(V7Start, "V7Start");
    }
    return jump(V6EndDay, "V6EndDay");


};
